import React from "react";
import { InfoLine, InfoVert } from "../";
import { FormatDate } from "_assets/js/helpers";
import "./Personal.scss";

const AddressList = (props) => {
  const { address } = props;

  return (
    <div className="item-list">
      <div>
        {address?.streetPrefix} {address?.streetName} {address?.streetSuffix}
        {address?.unitType && address?.unitId && (
          <>
            <br />
            {address?.unitType} {address?.unitId}
          </>
        )}
        <br />
        {address?.city}, {address?.state} {address?.zipCode?.substring(0, 5)}
      </div>
      {address?.dwellingType && (
        <p>
          {address.dwellingType === "S"
            ? "Single Family"
            : address.dwellingType === "A"
            ? "Multi-Family Dwelling"
            : address.dwellingType === "M"
            ? "Marginal Multi-Family"
            : address.dwellingType === "P"
            ? "PO Box"
            : address.dwellingType}
        </p>
      )}
      {address?.firstReportedDate && address?.lastUpdatedDate && (
        <p>
          Reported {FormatDate(address?.firstReportedDate)} to&nbsp;
          {FormatDate(address?.lastUpdatedDate)}
        </p>
      )}
    </div>
  );
};

function Personal(props) {
  const { report } = props;

  // Extract Experian personal data
  const names = report?.consumerIdentity?.name || [];
  const primaryName = names.find((n) => n.type === "N") || names[0]; // Type N = Primary name
  const aliases = names.filter((n) => n.type === "A"); // Type A = Alias

  const addresses = report?.addressInformation || [];
  const currentAddress = addresses[0]; // First address is usually current
  const otherAddresses = addresses.slice(1);

  const employments = report?.employmentInformation || [];
  const currentEmployment = employments[0]; // First employment entry
  const otherEmployment = employments[1];

  return (
    <div id={props.id} className="wzrd-box personal">
      <div className="wzrd-header">
        <h3>Personal Information</h3>
      </div>
      <div className="wzrd-body">
        <InfoLine
          title="Best Name"
          info={`${primaryName?.firstName || ""} ${
            primaryName?.middleName || ""
          } ${primaryName?.surname || ""}`}
        />
        {aliases && aliases.length > 0 && (
          <InfoLine
            title="Other Name(s)"
            info={aliases
              .map(
                (n) =>
                  `${n?.firstName || ""} ${n?.middleName || ""} ${
                    n?.surname || ""
                  }`
              )
              .join("; ")}
          />
        )}
        {/* Note: SSN not provided in this Experian format */}
        {currentEmployment && (
          <InfoLine title="Best Employer" info={currentEmployment?.name} />
        )}
        {otherEmployment && (
          <InfoLine title="Other Employer" info={otherEmployment?.name} />
        )}
        {currentAddress && (
          <InfoVert title="Best Address">
            <AddressList address={currentAddress} />
          </InfoVert>
        )}
        {otherAddresses && otherAddresses.length > 0 && (
          <InfoVert title="Other Address(es)" last>
            <div className="columns">
              {otherAddresses?.map((a, i) => (
                <AddressList key={`al-${i}`} address={a} />
              ))}
            </div>
          </InfoVert>
        )}
      </div>
    </div>
  );
}

export default Personal;
